import React from "react";
import { Grid, Typography, Paper } from "@mui/material";
import SectionWrapper from "./SectionWrapper";

const title =
  "Vad behöver Ni hjälp med? Tveka inte att kontakta mig, vi hittar säkert en lösning. Några exempel:";
const exempel: string[] = [
  "Byggstädning, transporter och handräckning inom bygge",
  "Montering och demontering",
  "Klippa gräsmatta eller häck. Rensa ogräs. Måla staketet.",
  "Röja på vind, i garage eller förråd.",
  "Bilservice. Byte olja och filter, eller har ni fått en 2:a på besiktningen.",
  "Reparation personbilssläp",
];

const Services: React.FC = () => {
  return (
    <SectionWrapper name="services" bg={undefined} minHeight="70vh">     
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography
            variant="h3"
            component="div"
            gutterBottom
            sx={{
              fontSize: {
                xs: "1.5rem",
                sm: "2rem",
                md: "2.5rem",
              },
            }}
          >
            Tjänster
          </Typography>
        <Typography variant="h5" component="div" gutterBottom sx={{ mb: 4, fontSize: { xs: "1rem", sm: "1.25rem" } }}>
          {title}
        </Typography>
        <Grid container spacing={{ xs: 2, sm: 4 }}>
          {exempel.map((service, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, height: "100%" }}>
                <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem" } }}>
                  {service}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </SectionWrapper>
  );
};

export default Services;
